export const DEFAULT_SLIDE_HEIGHT = 100;
export const LEFT_BUTTON_CLICKED = 'LEFT_BUTTON_CLICKED';
export const RIGHT_BUTTON_CLICKED = 'RIGHT_BUTTON_CLICKED';
export const CARD_MAPPING = {
    L: {
        breakpointL: {
            gutter: 16,
            cardsPerRow: 3,
        },
        breakpointLM: {
            gutter: 16,
            cardsPerRow: 3,
        },
        breakpointM: {
            gutter: 16,
            cardsPerRow: 3,
        },
        breakpointMS: {
            gutter: 16,
            cardsPerRow: 2,
        },
        breakpointS: {
            gutter: 12,
            cardsPerRow: 2,
        },
        breakpointSS: {
            gutter: 12,
            cardsPerRow: 1,
        },
        breakpointXS: {
            gutter: 8,
            cardsPerRow: 1,
        },
    },
    M: {
        breakpointL: {
            gutter: 16,
            cardsPerRow: 4,
        },
        breakpointLM: {
            gutter: 16,
            cardsPerRow: 4,
        },
        breakpointM: {
            gutter: 16,
            cardsPerRow: 4,
        },
        breakpointMS: {
            gutter: 16,
            cardsPerRow: 3,
        },
        breakpointS: {
            gutter: 12,
            cardsPerRow: 3,
        },
        breakpointSS: {
            gutter: 12,
            cardsPerRow: 2,
        },
        breakpointXS: {
            gutter: 8,
            cardsPerRow: 1,
        },
    },
    S: {
        breakpointL: {
            gutter: 16,
            cardsPerRow: 4,
        },
        breakpointLM: {
            gutter: 16,
            cardsPerRow: 4,
        },
        breakpointM: {
            gutter: 16,
            cardsPerRow: 4,
        },
        breakpointMS: {
            gutter: 16,
            cardsPerRow: 3,
        },
        breakpointS: {
            gutter: 12,
            cardsPerRow: 3,
        },
        breakpointSS: {
            gutter: 12,
            cardsPerRow: 2,
        },
        breakpointXS: {
            gutter: 8,
            cardsPerRow: 1,
        },
    },
};
